import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { PermissionSetModel } from "../models/PermissionsModels/PermissionSetModel";
import { PermissionSetUsersIDRequestModel } from "../models/PermissionsModels/PermissionSetUsersIDRequestModel";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bbsf-utilities";


@Injectable({
  providedIn: 'root'
})
export class PermissionSetService {
  ApiUrl = "/api/admin/PermissionSets/"
  constructor(private http: RequestHandlerService) {
  }

  Loaddropdowns(){
    
    return this.http.get( this.ApiUrl + 'Loaddropdowns');
  }
  AddPermissionSet(AddModel: PermissionSetModel) {
   
    return this.http.post( this.ApiUrl + 'AddPermissionSet', AddModel);
  }

  EditPermissionSet( EditModel: PermissionSetModel) {
    return this.http.post( this.ApiUrl + 'EditPermissionSet', EditModel);
  }
  
  DeletePermissionSet(UsersIDRequestModel: UsersIDRequestModel) {
  
    return this.http.post( this.ApiUrl + 'DeletePermissionSet', UsersIDRequestModel);
  }
  

  AddUsersToPermissionSet(AddModel: PermissionSetUsersIDRequestModel) {
    
    return this.http.post( this.ApiUrl + 'AddUsersToPermSet', AddModel);
  }


  DeleteUserFromPermissionSet(userID:string,permSetID:string) {
    let params = new HttpParams();
    params = params.append("userID",userID);
    params = params.append("permSetID",permSetID);
    return this.http.post( this.ApiUrl + 'DeleteUserFromPermissionSet', null,params);
  }
  
  
}